<template>
    <content-view>
        <template #header>
            <div class="home-head">
                <bread-crumb :buttonColor="'#74AE2A'" :activeText="$t('nav.event')"></bread-crumb>
                <v-spacer></v-spacer>
                <div class="sub-header">{{ $t("event.entry-headline") }}</div>
            </div>
        </template>
        
        <template #content>
            <div class="content-wrapper">
                <v-card rounded="xl" elevation="9">
                    <v-img class="event-entry-header-wrapper" :style="{backgroundColor: '#74AE2A'}">
                        <v-card-text class="d-flex event-entry-headline-text justify-center align-center">
                            <v-btn  :to="{name: 'event', params: {date: getPreviousDay()}}" :disabled="isFirstDay" :class="{hide: isFirstDay}" class="change-day-button">
                                <v-icon class="change-day-icon">mdi-menu-left</v-icon>
                            </v-btn>
                            <span style="width: 35vw;">{{getDayFromEvent()}}</span>
                            <v-btn :to="{name: 'event', params: {date: getNextDay()}}" class="change-day-button" :disabled="isLastDay" :class="{hide: isLastDay}">
                                <v-icon class="change-day-icon">mdi-menu-right</v-icon>
                            </v-btn>
                        </v-card-text>
                    </v-img>
                    <div class="event-wrapper" :class="{'scroll': todaysEvents.length > 3}" v-if="todaysEvents !== undefined && todaysEvents.length !== 0">
                        <div v-for="(event, index) in todaysEvents" :key="event.id">
                            <event-entry-view  :event="event" :index="index" :length="todaysEvents.length"></event-entry-view>
                            <v-divider class="middle-divider event-divider" v-if="index !== (todaysEvents.length -1)"></v-divider>
                        </div>
                    </div>
                    <div class="event-wrapper" v-else>
                        <v-row class="menu-entry-empty-text empty-event d-flex justify-center align-center">{{ $t("event.entry-empty") }}</v-row>
                    </div>
                </v-card>
            </div>
        </template>
    </content-view>
</template>
<style lang="scss">
.content-wrapper {
    display: grid;
    grid-template-rows: auto;
    height: 100%;
}
.empty-event {
    min-height: 13vh;
    height: 13vh;
    max-height: 13vh;
}
.change-day-button{
    height: 6vh !important;
    width: 4.5vw !important;
    border-radius: 1.2vh !important;
    margin: 0 3vw;
}
.change-day-icon{
    font-size: 8vh !important;
    color: $font-color !important;
}
.event-wrapper{
    height: 50vh;
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    padding: 3vh 3vw;
}
.event-divider {
    margin: 3vh 0;
}
.scroll{
    overflow: auto;
}
.event-entry-header-wrapper{
    height: 9vh;
}
.event-entry-headline-text{
    height: 100%;
    text-align: center; //ist für längere Texte zusätzlich notwendig
    font: normal normal bold 3.5vh/6vh 'RobotoRegular' !important;
    letter-spacing: 2px !important;
    color: white !important;
}
.event-entry-empty-text{
    height: 100%;
    text-align: center; //ist für längere Texte zusätzlich notwendig
    font: normal normal bold 3.5vh/6vh 'RobotoRegular' !important;
    letter-spacing: 3px !important;
    color: $font-color !important;
}
.hide {
    opacity: 0;
}
</style>
<script>
import moment from 'moment';
export default {
    data() {
        return {
            loading: true,
            daySpan: 20,
        }
    },
    created() {
        let now = moment(moment.now());
        this.$store.dispatch({
            type: 'moduleEvents/fetchEvents',
            startDate: now.subtract(this.daySpan, 'days').format('YYYY-MM-DD'),
            endDate: now.add(this.daySpan*2, 'days').format('YYYY-MM-DD'),
        }).catch((error) => {
            if(error.response.status === 401) {
                this.$root.$emit('unauthenticated');
            } else {
                this.apiErrorMessageHandler(error);
            }
        });
    },
    methods: {
        getEventsForDate(date) {
            return this.events.filter(event => {return event.date === date});
        },
        getDayFromEvent() {
            let format = 'dddd, DD.MM.YYYY';
            if(this.selectedDay === undefined) {
                return moment(moment.now()).locale('de').format(format);
            } else if(this.isToday) {
                format = '[Heute], DD.MM.YYYY'
            }
            return moment(this.selectedDay).locale('de').format(format);
        },
        getPreviousDay() {
            return moment(this.$route.params.date).subtract(1, 'days').format('YYYY-MM-DD');
        },
        getNextDay() {
            return moment(this.$route.params.date).add(1, 'days').format('YYYY-MM-DD');
        },
    },
    computed: {
        isFirstDay() {
            let firstDay = moment(moment.now()).subtract(this.daySpan, 'days').format('YYYY-MM-DD');
            return moment(this.selectedDay).isSame(firstDay);
        },
        isToday() {
            let today = moment(moment.now()).format('YYYY-MM-DD');
            return moment(this.selectedDay).isSame(today);
        },
        isLastDay() {
            let lasttDay = moment(moment.now()).add(this.daySpan, 'days').format('YYYY-MM-DD');
            return moment(this.selectedDay).isSame(lasttDay);
        },
        events() {
            return this.$store.getters['moduleEvents/events'];
        },
        todaysEvents() {
            return this.getEventsForDate(this.$route.params.date);
        },
        selectedDay() {
            return moment(this.$route.params.date).format('YYYY-MM-DD');
        }
    }
}
</script>
